import React, { ReactElement } from 'react';
import classnames from 'classnames';
import { ColumnInstance } from 'react-table';
import styles from './index.module.css';

interface ResizeHandleProps<T extends Record<string, unknown>> {
  className?: string;
  column: ColumnInstance<T>;
}

export function ResizeHandle<T extends Record<string, unknown>>({
  className,
  column,
}: ResizeHandleProps<T>): ReactElement {
  return (
    <div
      {...column.getResizerProps()}
      style={{ cursor: 'col-resize' }}
      className={classnames(styles.root, className, {
        [styles.active]: column.isResizing,
      })}
    />
  );
}
